/**
 * As rotas de listagem nem sempre respondem uma lista: em falha algumas devolvem
 * o objeto de erro, e em 204 o corpo vem vazio. Sem essa guarda o valor cai
 * direto no state e a tela quebra no primeiro .filter/.map do render.
 *
 * @param {unknown} data - o corpo da resposta
 * @returns {Array} o próprio corpo quando já é uma lista, senão uma lista vazia
 */
export function asList(data) {
  return Array.isArray(data) ? data : [];
}
